import { spacing2x, spacing4x, borderRadiusMd } from "@airhelp/design-tokens";
import Checkbox from "./Checkbox.js";
const disabledStyle = {
    borderColor: "greyscale.400",
    background: "greyscale.100",
    span: {
        borderColor: "greyscale.400",
        background: "greyscale.200",
        _checked: {
            borderColor: "greyscale.400",
            background: "greyscale.100",
            _before: {
                background: "greyscale.400",
            },
        },
    },
};
const baseStyle = {
    container: {
        padding: spacing4x,
        border: "1px solid",
        borderColor: "greyscale.500",
        borderRadius: borderRadiusMd,
        background: "greyscale.100",
        marginTop: "-1px !important",
        _disabled: disabledStyle,
        _hover: {
            zIndex: 1,
            borderColor: { md: "primary.300" },
            _disabled: {
                ...disabledStyle,
                "span:first-of-type": {
                    borderColor: "greyscale.400",
                    background: "greyscale.200",
                    _before: {
                        background: "greyscale.200",
                    },
                },
            },
            "span:first-of-type": {
                borderColor: { md: "primary.300" },
                _before: {
                    md: {
                        background: "primary.300",
                        content: "''",
                        display: "inline-block",
                        position: "relative",
                        w: spacing2x,
                        h: spacing2x,
                        borderRadius: "50%",
                    },
                },
            },
        },
        _active: {
            borderColor: "greyscale.500",
            background: "greyscale.300",
            _disabled: {
                ...disabledStyle,
            },
            span: {
                borderColor: "primary.700",
                _before: {
                    background: "primary.700",
                },
                _checked: {
                    background: "greyscale.300",
                },
            },
            _hover: {
                borderColor: "greyscale.500",
                background: "greyscale.300",
                _disabled: {
                    ...disabledStyle,
                },
                span: {
                    borderColor: "primary.700",
                    _before: {
                        background: "greyscale.100",
                    },
                },
                _checked: {
                    "span:first-of-type": {
                        background: "greyscale.100",
                        _before: {
                            background: "primary.700",
                        },
                    },
                },
            },
        },
        _checked: {
            zIndex: 1,
            borderColor: "primary.500",
            _disabled: disabledStyle,
            _hover: {
                borderColor: { md: "primary.300" },
                _disabled: disabledStyle,
            },
            _active: {
                borderColor: "greyscale.500",
                _disabled: disabledStyle,
            },
        },
    },
    control: {
        ...Checkbox.baseStyle.control,
        borderRadius: "full",
        _checked: {
            // eslint-disable-next-line no-underscore-dangle
            ...Checkbox.baseStyle.control._checked,
            background: "greyscale.100",
            _hover: {
                borderColor: { md: "primary.300" },
                background: { md: "greyscale.100" },
                _before: {
                    background: { md: "primary.300" },
                },
            },
            _active: {
                borderColor: "primary.700",
                _before: {
                    background: "primary.700",
                },
            },
            _before: {
                w: spacing2x,
                h: spacing2x,
                bg: "primary.500",
            },
        },
    },
    label: {
        ...Checkbox.baseStyle.label,
        width: "100%",
    },
};
const variants = {
    top: {
        container: {
            borderBottomRadius: 0,
        },
    },
    bottom: {
        container: {
            borderTopRadius: 0,
        },
    },
    left: {
        container: {
            borderRightRadius: 0,
        },
    },
    right: {
        container: {
            borderLeftRadius: 0,
        },
    },
    center: {
        container: {
            borderRadius: 0,
        },
    },
    rounded: {
        container: {
            borderRadius: borderRadiusMd,
        },
    },
};
const defaultProps = {
    variant: "rounded",
};
const Radio = {
    baseStyle,
    defaultProps,
    variants,
};
export default Radio;
